import {AfterViewInit, Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {finalize} from 'rxjs/operators';

import {GetSaseungTxt} from 'src/app/shared/defines/gukeo.func';
import {BookmarkChange} from '../../shared/defines/client.const';
import {Saseung3} from "../../shared/models/saseung3.model";
import {Saseung3BookmarkService} from "../../shared/services/saseung3-hanja/saseung3-bookmark.service";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";


@Component({
  selector: 'app-saseung3-item',
  templateUrl: './saseung3-item.component.html',
  styleUrls: ['./saseung3-item.component.scss']
})
export class Saseung3ItemComponent implements AfterViewInit {
  @HostBinding('class.detail-mode') get detailModeClass(): boolean {
    return this.detailMode;
  }
  @Input() saseung3?: Saseung3;
  @Input() showHangul: boolean = false;
  @Input() showBookmarkButton: boolean = true;
  @Input() detailMode: boolean = false;
  @Output() viewInit = new EventEmitter<Saseung3>();
  @Output() bookmarkChange = new EventEmitter<BookmarkChange>();

  private sendingBookmark = false;

  constructor(
    private bmSvc: Saseung3BookmarkService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  ngAfterViewInit(): void {
    if (this.saseung3) {
      this.viewInit.emit(this.saseung3);
    }
  }

  /**
   * 사성 심볼(P/S/G/I/K/B)을 한글로 변환
   */
  public GetSaseungTxt(symbol: string): string {
    const saseungTxt = GetSaseungTxt(symbol);
    if (!saseungTxt) {
      console.error('Saseung3ItemComponent::GetSaseungTxt() invalid saseung symbol', symbol);
    }
    return saseungTxt ? saseungTxt : '';
  }

  /**
   * four_tones 문자열에서 각 사성을 배열로 분리
   * 예: "PG" -> ["P", "G"]
   */
  public getFourTonesArray(): string[] {
    if (!this.saseung3?.four_tones) {
      return [];
    }
    return this.saseung3.four_tones.split('');
  }

  /**
   * 훈을 파이프로 분리한 배열
   */
  private get hunParts(): string[] {
    if (!this.saseung3?.meaning) return [];
    return this.saseung3.meaning.split('|');
  }

  /**
   * 훈에서 첫 번째 훈만 추출
   */
  get firstHun(): string {
    return this.hunParts[0] ?? '';
  }

  /**
   * 훈에서 첫 번째를 제외한 나머지 훈 반환
   * 입력: 파이프(|)로 구분된 meaning 문자열
   * 출력: 중간점(' · ')으로 구분된 문자열
   */
  get restHun(): string {
    const rest = this.hunParts.slice(1);
    return rest.length > 0 ? rest.join(' · ') : '';
  }

  protected ToggleBookmark(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    const saseung3 = this.saseung3;
    if (!saseung3 || this.sendingBookmark) {
      return;
    }
    if (saseung3.id === null) {
      console.error('Saseung3ItemComponent::ToggleBookmark() saseung3.id is null', saseung3);
      return;
    }

    this.sendingBookmark = true;
    saseung3.bookmark = !saseung3.bookmark;
    this.bmSvc.sendBookmark(saseung3.id, saseung3.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe({
      next: () => this.bookmarkChange.emit({id: saseung3.id!, bookmark: saseung3.bookmark}),
      error: err => {
        console.error('Saseung3ItemComponent::ToggleBookmark() failed', saseung3.id, err);
        saseung3.bookmark = !saseung3.bookmark;
      },
    });
  }

  protected getBmCss(saseung3: Saseung3): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return saseung3.bookmark ? 'on' : '';
  }
}
